<app-star-button
  [showLoading]="emailsPageStateService.isLoadingStarred()"
  (click)="actions.addEmailToStar()" />

@for (button of emailsService.commonActionButtons; track button) {
  @switch (button) {
    @case (EmailActionsEnum.Validate) {
      <app-validate-button
        [disabled]="emailsPageStateService.isLoadingValidate()"
        [showButton]="
          emailsService.validateIsAvailable &&
          !emailsPageStateService.isLoadingValidate()
        "
        [showLoading]="emailsPageStateService.isLoadingValidate()"
        (click)="actions.setValidated()" />
    }

    @case (EmailActionsEnum.DeleteFinalMail) {
      <app-final-delete-button (click)="actionsModals.finalDelete()" />
    }

    @case (EmailActionsEnum.Reply) {
      <app-reply-button
        [showButton]="
          emailsService.oneSelected &&
          !(
            !!emailsPageStateService.replyingEmailId() &&
            emailsPageStateService.loadingActionFromHeader()
          )
        "
        [disabled]="emailsPageStateService.isAnyActionInProgress()"
        [showLoading]="
          !!emailsPageStateService.replyingEmailId() &&
          emailsPageStateService.loadingActionFromHeader() &&
          emailsService.oneSelected
        "
        (click)="buttonActionsService.reply()" />
    }

    @case (EmailActionsEnum.ReplyAll) {
      <app-reply-all-button
        [showButton]="
          emailsService.oneSelected &&
          !(
            !!emailsPageStateService.replyingAllEmailId() &&
            emailsPageStateService.loadingActionFromHeader()
          )
        "
        [disabled]="emailsPageStateService.isAnyActionInProgress()"
        [showLoading]="
          !!emailsPageStateService.replyingAllEmailId() &&
          emailsPageStateService.loadingActionFromHeader() &&
          emailsService.oneSelected
        "
        (click)="buttonActionsService.replyAll()" />
    }

    @case (EmailActionsEnum.Forward) {
      @if (emailsService.oneSelected) {
        <app-forward-button
          [showButton]="
            !(
              !!emailsPageStateService.forwardingAsTextEmailId() &&
              emailsPageStateService.loadingActionFromHeader()
            )
          "
          [disabled]="emailsPageStateService.isAnyActionInProgress()"
          [showLoading]="
            !!emailsPageStateService.forwardingAsTextEmailId() &&
            emailsPageStateService.loadingActionFromHeader()
          "
          (click)="buttonActionsService.forward()" />
        <app-forward-attachment-button
          [showButton]="
            !(
              !!emailsPageStateService.forwardingAsAttachmentEmailId() &&
              emailsPageStateService.loadingActionFromHeader()
            )
          "
          [disabled]="emailsPageStateService.isAnyActionInProgress()"
          [showLoading]="
            !!emailsPageStateService.forwardingAsAttachmentEmailId() &&
            emailsPageStateService.loadingActionFromHeader()
          "
          (click)="buttonActionsService.forwardAsAttachment()" />
      } @else {
        <app-forward-attachment-button
          [showButton]="
            !(
              !!emailsPageStateService.forwardingAsAttachmentEmailId() &&
              emailsPageStateService.loadingActionFromHeader()
            )
          "
          [disabled]="emailsPageStateService.isAnyActionInProgress()"
          [showLoading]="
            !!emailsPageStateService.forwardingAsAttachmentEmailId() &&
            emailsPageStateService.loadingActionFromHeader()
          "
          (click)="buttonActionsService.forwardAsAttachment()" />
      }
    }

    @case (EmailActionsEnum.Reassign) {
      @if (emailsPageStateService.multipleReassignIsAvailable()) {
        <app-reassign-button (click)="actionsModals.reassign()" />
      }
    }

    @case (EmailActionsEnum.Groups) {
      <app-groups-button (click)="actionsModals.openAddGroupDialog()" />
    }

    @case (EmailActionsEnum.Tags) {
      <app-tags-button (click)="actionsModals.openAddTagDialog()" />
    }

    @case (EmailActionsEnum.SetRead) {
      <app-set-read-button (click)="actions.setSeen(true)" />
    }

    @case (EmailActionsEnum.SetUnread) {
      <app-set-unread-button (click)="actions.setSeen(false)" />
    }

    @case (EmailActionsEnum.MarkAsSpam) {
      <app-mark-as-span-button (click)="actions.setSpam()" />
    }

    @case (EmailActionsEnum.Delete) {
      <app-delete-button (click)="actionsModals.delete()" />
    }

    @case (EmailActionsEnum.DownloadSingleEml) {
      <app-download-single-eml-button
        [showButton]="!emailsPageStateService.isDownloadingSingleEML()"
        [showLoading]="emailsPageStateService.isDownloadingSingleEML()"
        (click)="actions.downloadSingleEML()" />
    }

    @case (EmailActionsEnum.DownloadEml) {
      <app-download-eml-button
        [showButton]="!emailsPageStateService.isDownloadingEML()"
        [showLoading]="emailsPageStateService.isDownloadingEML()"
        (click)="actions.downloadEML()" />
    }

    @case (EmailActionsEnum.Restore) {
      <app-restore-button (click)="actionsModals.restoreFromTrash()" />
    }

    @case (EmailActionsEnum.MarkAsNotSpam) {
      <app-mark-as-not-span-button
        (click)="
          buttonActionsService.restoreMoveFolderChoose(
            emailsPageStateService.selection.selected,
            'restoreOneSpam'
          )
        " />
    }

    @case (EmailActionsEnum.MoveToFolder) {
      <app-move-to-folder-button (click)="actionsModals.move()" />
    }

    @case (EmailActionsEnum.Archive) {
      <app-archive-button (click)="actionsModals.setSelectedArchive()" />
    }

    @case (EmailActionsEnum.Audit) {
      @if (emailsService.oneSelected) {
        <app-audit-button (click)="actionsModals.openAudit()" />
      }
    }

    @case (EmailActionsEnum.RetrySending) {
      @if (emailsService.isSelectedRetrySendingNeededState) {
        <app-retry-sending-button (click)="actions.retrySend()" />
      }
    }

    @case (EmailActionsEnum.RestoreArchive) {
      <app-restore-archive-button
        (click)="actionsModals.restoreFromArchive()" />
    }

    @case (EmailActionsEnum.Archiving) {
      <app-archiving-button (click)="actionsModals.archiving()" />
    }
  }
}
